import React from "react";
import { Button } from "@mui/material";
import useGA4Event from "../hooks/useGA4Event";

export default function MoveButton(props) {
  const sendGA4Event = useGA4Event();

  const handleClick = (event) => {
    sendGA4Event('button_click', {
      'button_id': props.id || 'move_button',
      'button_text': props.title,
      'button_state': props.selected ? 'selected' : 'unselected',
      'page_path': window.location.pathname,
    });

    if (props.onClick) {
      props.onClick(event);
    }
  };

  return (
    <Button
      variant={props.selected ? "contained" : "outlined"}
      color="secondary"
      onClick={handleClick}
      disabled={props.disabled}
      startIcon={
        props.IconComponent ? (
          <props.IconComponent
            style={{
              width: 17,
              height: 17,
              fill: props.selected ? "#2200BB" : "black",
            }}
          />
        ) : null
      }
      sx={{
        fontFamily: "Inter, sans-serif",
        fontWeight: 600,
        width: "100%",
        minHeight: "clamp(50px, 6vh, 80px)",
        fontSize: "clamp(12px, 2.5vh, 16px)",
        borderStyle: "solid",
        borderWidth: "1.5px",
        borderColor: props.selected ? "piction.highlight" : "grayTones.piction",
        backgroundColor: props.selected
          ? "piction.bgHighlight"
          : "piction.background",
        color: "black",
        justifyContent: "flex-start",
        pl: 5,
        p: 2,
        "&:hover": {
          backgroundColor: props.selected
            ? "piction.bgHighlight"
            : "rgba(34, 0, 187, 0.04)",
          borderColor: "piction.highlight",
          borderWidth: "2px",
          color: "black",
        },
        "&:disabled": {
          backgroundColor: "grey.200",
          borderColor: "grey.400",
          color: "grey.500",
        },
        borderRadius: "25px",
        transition: "all 0.3s ease",
        ...props.sx,
      }}
    >
      {props.title}
    </Button>
  );
}